import Table, { TableProps } from "@components/Table";

export type SearchSubscriptionsProps = {
  className?: string;
  userId: number;
  organizationUuid: string;
};

import { useAlert } from "@/contexts/AlertContext";
import QuickSubscribe from "@/views/MentionsView/partials/QuickSubscribe";

import styles from "./SearchSubscriptions.module.css";

/**
 * SearchSubscriptions
 * accepts a User and a OrganizationUuid and allows reusable setting of the
 * search subscriptions for that user.
 */
const SearchSubscriptions: React.FunctionComponent<
  SearchSubscriptionsProps & TableProps
> = ({ userId, organizationUuid, ...props }) => {
  const { groupedAlerts } = useAlert();

  return (
    <Table {...props}>
      <thead className={styles.sticky}>
        <tr>
          <th className={styles.tableName}>
            {L.ORGANIZATION_USER_SEARCH_TABLE_TITLE}
          </th>
          <th>{L.ORGANIZATION_USER_REPORT_TABLE_INTERVAL}</th>
        </tr>
      </thead>
      <tbody>
        {(groupedAlerts?.active || [])?.map((search) => (
          <tr key={search.uuid}>
            <td>{search.title}</td>
            <td>
              <QuickSubscribe
                user_id={userId}
                organization_uuid={organizationUuid}
                search_uuid={search.uuid}
              />
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export default SearchSubscriptions;
